module.exports = __webpack_public_path__ + "img/logo.9f59e726.png";